// extracted by mini-css-extract-plugin
export var expandable = "SidebarLinks-module--expandable--e2afc";
export var open = "SidebarLinks-module--open--bbfba";
export var sidebarLinks = "SidebarLinks-module--sidebarLinks--ddfca";
export var sublink = "SidebarLinks-module--sublink--b4fb8";